import React, { useRef, useState } from "react";
import {
  FormCreationData,
  DeviceType,
} from "../../../../../stateManager/store/formCreation_v2/types";
import { Grid, GridWithBadge } from "../components/Grid";
import { ExpansionPanel } from "../components/ExpansionPanel";
import { Flex, FlexWithBadge } from "../components/Flex";
import { Container, ContainerWithBadge } from "../components/container";
import { TabBar } from "../components/TabBar";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { createPortal } from "react-dom";
import { FormWizardSteps } from "../components/FormWizard";
import { FlatList } from "../components/FlatList";

export const flexContainers = ['Row', 'Column']
export const gridContainers = ['Grid', 'ExpansionPanel', 'CustomModal', 'TabBar']

export const HandleContainersV3 = (props: {
  element: FormCreationData;
  deviceType: DeviceType;
  isCheckedIn?: Boolean;
  zoomScale?: any;
  index?: Number
}) => {
  const portalRef: any = useRef(null)
  const { element, deviceType, index } = props;

  const style = element?.properties?.styles || {};
  const isElementFixed = style[deviceType]?.fixed

  const enableBadge = Object.hasOwn(element?.properties?.config, "enableBadge")

  const componentMap: Record<string, React.ElementType> = {
    "Grid": enableBadge ? GridWithBadge : Grid,
    "Row": enableBadge ? FlexWithBadge : Flex,
    "Column": enableBadge ? FlexWithBadge : Flex,
    "Container" : enableBadge ? ContainerWithBadge : Container,
    "TabBar": TabBar,
    "ExpansionPanel": ExpansionPanel,
    "FormWizard": FormWizardSteps,
    "FlatList": FlatList
  }

  const Component = componentMap[props.element.type]

  if(!Component) {
    return null
  }

  if (isElementFixed) {
    const fixedRoot = document.getElementById("canvasFixedElement")
    const elementNode = document.getElementById(element.id)
    // if (elementNode?.children.length) {
    //   return portalRef.current
    // }
    if (fixedRoot) {
      const portal = createPortal(<Component {...props}/>, fixedRoot)
      portalRef.current = portal
      return portal
    }

    return null
  }

  return <Component isCoreV3={true} {...props} index={index} />
};
